import { IconSvg, IconSvgProps } from "./icon"

export default function Alert(props: IconSvgProps) {
  return (
    <IconSvg {...props}>
      <path d="M13.027 5.128a1.155 1.155 0 0 0-2.054 0l-6.35 12.698A1.154 1.154 0 0 0 5.651 19.5h12.698a1.152 1.152 0 0 0 1.027-1.674L13.027 5.128ZM12 9.688v3.463" />
      <path d="M12 17.191a.577.577 0 1 0 0-1.154.577.577 0 0 0 0 1.154Z" />
    </IconSvg>
  )
}
